export default {
  noDataToCompare: 'No job selected for comparison.',
};
